import { msalConfig } from '@cloudpremise/portal_core';
const Config = {
  REACT_APP_MS_CLIENT_ID: null,
  REACT_APP_MS_AUTHORITY_URL: null,
  REACT_APP_S3_REGION: null,
  REACT_APP_S3_BUCKET: null,
  REACT_APP_S3_ACCESS_KEY: null,
  REACT_APP_S3_ACCESS_SECRET: null,
  REACT_APP_S3_DEFAULT_PATH: "/",
  REACT_APP_MAPBOX_ACCESS_TOKEN: null,
  REACT_APP_GOOGLE_CLIENT_ID: null,
  REACT_APP_GITHUB_CLIENT_ID: null,
  REACT_APP_FACEBOOK_APP_ID: null,
  getAppTitle(){
    if(process.env.REACT_APP_TITLE){
      return process.env.REACT_APP_TITLE;
    }
    return "Iris Portal";
  },
  getMsClientId: function() {
    if(this.REACT_APP_MS_CLIENT_ID){
      return this.REACT_APP_MS_CLIENT_ID;
    }
    if (process.env.REACT_APP_MS_CLIENT_ID) {
      return process.env.REACT_APP_MS_CLIENT_ID;
    }
  },
  getMsAuthorityUrl: function() {
    if(this.REACT_APP_MS_AUTHORITY_URL){
      return this.REACT_APP_MS_AUTHORITY_URL;
    }
    if (process.env.REACT_APP_MS_AUTHORITY_URL) {
      return process.env.REACT_APP_MS_AUTHORITY_URL;
    }
  },
  getMsalConfig: function (){
    msalConfig.auth.clientId = this.getMsClientId();
    msalConfig.auth.authority = this.getMsAuthorityUrl();
    return msalConfig;
  },
  getCdnUrl: function () {
    try {
      if (process.env.REACT_APP_CDN_URL) {
        return process.env.REACT_APP_CDN_URL;
      }
    } catch (e) {}
    return "";
  },
  getAwsBucket: function() {
    if(this.REACT_APP_S3_BUCKET){
      return this.REACT_APP_S3_BUCKET;
    }
    if (process.env.REACT_APP_S3_BUCKET) {
      return process.env.REACT_APP_S3_BUCKET;
    }
  },
  getAwsBucketDefaultPath: function() {
    let defaultPath = "";
    if(this.REACT_APP_S3_DEFAULT_PATH){
      defaultPath = this.REACT_APP_S3_DEFAULT_PATH;
    }else if (process.env.REACT_APP_S3_DEFAULT_PATH){
      defaultPath = process.env.REACT_APP_S3_DEFAULT_PATH;
    }
    defaultPath = defaultPath.replace(/^\/+|\/+$/g, ''); //Remove starting slash
    defaultPath = defaultPath.replace(/\/+$/, '');; //Remove trailing slash
    if(defaultPath.length > 0){
      defaultPath += "/";
    }
    return defaultPath;
  },
  getMapboxAccessToken: function() {
    if(this.REACT_APP_MAPBOX_ACCESS_TOKEN){
      return this.REACT_APP_MAPBOX_ACCESS_TOKEN;
    }
    if (process.env.REACT_APP_MAPBOX_ACCESS_TOKEN) {
      return process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    }
  },
  getGoogleClientId: function() {
    if(this.REACT_APP_GOOGLE_CLIENT_ID){
      return this.REACT_APP_GOOGLE_CLIENT_ID;
    }
    if (process.env.REACT_APP_GOOGLE_CLIENT_ID) {
      return process.env.REACT_APP_GOOGLE_CLIENT_ID;
    }
  },
  getGithubClientId: function() {
    if(this.REACT_APP_GITHUB_CLIENT_ID){
      return this.REACT_APP_GITHUB_CLIENT_ID;
    }
    if (process.env.REACT_APP_GITHUB_CLIENT_ID) {
      return process.env.REACT_APP_GITHUB_CLIENT_ID;
    }
  },
  getFacebookAppId: function() {
    if(this.REACT_APP_FACEBOOK_APP_ID){
      return this.REACT_APP_FACEBOOK_APP_ID;
    }
    if (process.env.REACT_APP_FACEBOOK_APP_ID) {
      return process.env.REACT_APP_FACEBOOK_APP_ID;
    }
  },
};

export default Config;
